module.exports = __webpack_public_path__ + "static/media/Medellin_Bergen.32559fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/Medellin_Bergen.png
// module id = 27
// module chunks = 1